import { render, staticRenderFns } from "./SetupFrame.vue?vue&type=template&id=63fd2550"
import script from "./SetupFrame.vue?vue&type=script&lang=js"
export * from "./SetupFrame.vue?vue&type=script&lang=js"
import style0 from "./SetupFrame.vue?vue&type=style&index=0&id=63fd2550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports